<template>
  <div class="home_transaction_wrap">
    <div class="home_transaction_filter">
      <div class="top_btn_group">
        <div
          ref="topBtnScroll"
          class="top_btn_scroll"
          :class="{ top_btn_scroll_is_dragging: filterStripDragging }"
          @wheel="onFilterStripWheel"
          @pointerdown="onFilterStripPointerDown"
          @click.capture="onFilterStripClickCapture"
        >
          <div
            :class="homeTransactionFilter === 'ALL' && 'selected'"
            class="filter_btn filter_btn_all"
            @click="switchHomeTransactionFilter('ALL')"
          >
             {{ $t('home.all') }}
          </div>
          <div
            :class="homeTransactionFilter === 'PROXY_WITHDRAW' && 'selected'"
            class="filter_btn"
            @click="switchHomeTransactionFilter('PROXY_WITHDRAW')"
          >
            {{ $t('transactionDetail.chametSalary') }}
          </div>
          <div
            :class="homeTransactionFilter === 'SALARY' && 'selected'"
            class="filter_btn"
            @click="switchHomeTransactionFilter('SALARY')"
          >
            {{ $t('transactionDetail.userSalary') }}
          </div>
          <div
            :class="homeTransactionFilter === 'AGENT_FEE' && 'selected'"
            class="filter_btn"
            @click="switchHomeTransactionFilter('AGENT_FEE')"
          >
            {{ $t('transactionDetail.comm') }}
          </div>
          <div
            :class="homeTransactionFilter === 'GALA_SALARY' && 'selected'"
            class="filter_btn"
            @click="switchHomeTransactionFilter('GALA_SALARY')"
          >
            {{ $t('transactionDetail.gemgalaSalary') }}
          </div>
        </div>
        <img
          class="filter_icon"
          src="@/assets/transaction/filter_icon.png"
          @click="showAmountFilter = true"
        />
      </div>
    </div>
    <div class="transaction_container">
      <div class="transaction_top" @click="toTransactionRecord">
        {{ $t('transactionDetail.title') }}
        <div class="transaction_top_right">
          {{ $t('home.all') }}
          <img :class="$store.state.isMirroring && 'mirror'" class="jump_icon" src="@/assets/home/to_transfer.png" />
        </div>
      </div>
      <div class="list_area">
      <div v-if="activities.length === 0 && loading" class="loading_box">
        {{ $t('home.loading') }}
      </div>
      <van-list v-if="loading || activities.length > 0" v-model="loading" :finished="finished" :error.sync="error"
        :finished-text="$t('home.noMore')" :error-text="$t('home.reload')" @load="onLoad">
        <van-cell class="transaction_item_box" v-for="item in activities" :key="item.activityNo"
          @click="toTransactionDetail(item.activityNo)">
          <div class="transaction_item">
            <img v-if="cashWithdraw.indexOf(item.type) > -1" class="transaction_item_icon"
              src="@/assets/transaction/transactions_list_icon_cashout.png" />
            <img v-if="cashWithdrawRefund.indexOf(item.type) > -1" class="transaction_item_icon"
              src="@/assets/transaction/transactions_list_icon_cashout.png" />
            <img v-if="cashRecharge.indexOf(item.type) > -1" class="transaction_item_icon"
              src="@/assets/transaction/transactions_list_icon_expense.png" />
            <img v-if="cashIn.indexOf(item.type) > -1" class="transaction_item_icon"
              src="@/assets/transaction/transactions_list_icon_cashin.png" />
            <img v-if="cashOut.indexOf(item.type) > -1" class="transaction_item_icon"
              src="@/assets/transaction/transactions_list_icon_expense.png" />
            <img v-if="cashTransfer.indexOf(item.type) > -1" class="transaction_item_icon"
              src="@/assets/transaction/transactions_list_icon_transfer.png" />
            <div class="transaction_item_content">
              <div v-if="item.type === 0" class="transaction_item_des">
                {{ $t('home.receivedFrom') + ': ' + item.relatedUser + ' (' + item.relatedPhone + ')' }}
              </div>
              <div v-if="item.type === 1" class="transaction_item_des">
                {{ $t('home.transferredTo') + ': ' + item.relatedUser + ' (' + item.relatedPhone + ')' }}
              </div>
              <div v-if="item.type === 20" class="transaction_item_des">
                {{ $t('home.fee') + ' ' + item.relatedPhone }}
              </div>
              <div v-if="[0, 1, 20].indexOf(item.type) === -1" class="transaction_item_des">
                {{ item.remark }}
              </div>
              <div class="transaction_item_time">{{ formatDate(item.createTime) }} (GMT +0)</div>
            </div>
            <div class="transaction_item_amount">
              <span>
                {{
                  (transOut.indexOf(item.type) > -1 ? '-' : '') +
                  new Intl.NumberFormat('en', {
                    style: 'currency',
                    currency: 'USD',
                    currencyDisplay: 'symbol',
                    minimumFractionDigits: 0
                  }).format(item.amount)
                }}
              </span>
            </div>
          </div>
        </van-cell>
      </van-list>
      <NoData v-else class="no_data_box" />
      </div>
    </div>
    <TransactionAmountFilter
      v-model="showAmountFilter"
      :cur-min-amount="minAmount"
      :cur-max-amount="maxAmount"
      @setAmount="setAmount"
    />
  </div>
</template>

<script>
import { formatDate } from '@/utils'
import NoData from '@/components/noData'
import TransactionAmountFilter from '@/components/Transaction/TransactionAmountFilter.vue'

export default {
  name: 'HomeTransactionList',
  components: {
    NoData,
    TransactionAmountFilter
  },
  data() {
    return {
      homeTransactionFilter: 'ALL',
      showAmountFilter: false,
      minAmount: '',
      maxAmount: '',
      loading: true,
      finished: false,
      error: false,
      page: 1,
      activities: [],
      // 交易图标
      cashWithdraw: [9, 14],
      cashWithdrawRefund: [10, 16],
      cashIn: [7, 8, 19],
      cashOut: [4, 18],
      cashTransfer: [0, 1, 20],
      cashRecharge: [23],
      // 用户展示资金前的减号
      transOut: [1, 20, 9, 14, 4, 18, 23],
      filterStripDragging: false
    }
  },
  created() {
    this._filterStripDrag = {
      active: false,
      pointerId: null,
      startX: 0,
      startScrollLeft: 0,
      moved: false,
      draggingCommitted: false
    }
    this._onFilterStripDocPointerMove = this.onFilterStripDocumentPointerMove.bind(this)
    this._onFilterStripDocPointerUp = this.onFilterStripDocumentPointerUp.bind(this)
  },
  activated() {
    this.initData()
  },
  beforeDestroy() {
    this.endFilterStripPointerDrag()
  },
  methods: {
    formatDate,
    removeFilterStripDocumentListeners() {
      document.removeEventListener('pointermove', this._onFilterStripDocPointerMove, { capture: true })
      document.removeEventListener('pointerup', this._onFilterStripDocPointerUp, { capture: true })
      document.removeEventListener('pointercancel', this._onFilterStripDocPointerUp, { capture: true })
    },
    endFilterStripPointerDrag() {
      this.removeFilterStripDocumentListeners()
      const d = this._filterStripDrag
      d.active = false
      d.pointerId = null
      d.draggingCommitted = false
      d.moved = false
      this.filterStripDragging = false
    },
    onFilterStripPointerDown(e) {
      const el = this.$refs.topBtnScroll
      if (!el || el.scrollWidth <= el.clientWidth) {
        return
      }
      if (e.pointerType === 'mouse' && e.button !== 0) {
        return
      }
      this.endFilterStripPointerDrag()
      const d = this._filterStripDrag
      d.active = true
      d.pointerId = e.pointerId
      d.startX = e.clientX
      d.startScrollLeft = el.scrollLeft
      d.moved = false
      d.draggingCommitted = false
      document.addEventListener('pointermove', this._onFilterStripDocPointerMove, {
        capture: true,
        passive: false
      })
      document.addEventListener('pointerup', this._onFilterStripDocPointerUp, { capture: true })
      document.addEventListener('pointercancel', this._onFilterStripDocPointerUp, { capture: true })
    },
    onFilterStripDocumentPointerMove(e) {
      const d = this._filterStripDrag
      if (!d.active || e.pointerId !== d.pointerId) {
        return
      }
      const el = this.$refs.topBtnScroll
      if (!el) {
        return
      }
      const dx = e.clientX - d.startX
      if (!d.draggingCommitted) {
        if (Math.abs(dx) < 10) {
          return
        }
        d.draggingCommitted = true
        this.filterStripDragging = true
      }
      e.preventDefault()
      const maxScroll = el.scrollWidth - el.clientWidth
      el.scrollLeft = Math.max(0, Math.min(maxScroll, d.startScrollLeft - dx))
    },
    onFilterStripDocumentPointerUp(e) {
      const d = this._filterStripDrag
      if (!d.active || e.pointerId !== d.pointerId) {
        return
      }
      const wasDrag = d.draggingCommitted
      this.removeFilterStripDocumentListeners()
      d.active = false
      d.pointerId = null
      d.draggingCommitted = false
      d.moved = wasDrag
      this.filterStripDragging = false
    },
    onFilterStripClickCapture(e) {
      if (!this._filterStripDrag.moved) {
        return
      }
      e.preventDefault()
      e.stopPropagation()
      this._filterStripDrag.moved = false
    },
    onFilterStripWheel(e) {
      const el = this.$refs.topBtnScroll
      if (!el || el.scrollWidth <= el.clientWidth) {
        return
      }
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        return
      }
      if (e.deltaY === 0) {
        return
      }
      const maxScroll = el.scrollWidth - el.clientWidth
      const nextLeft = el.scrollLeft + e.deltaY
      if (e.deltaY > 0 && el.scrollLeft >= maxScroll) {
        return
      }
      if (e.deltaY < 0 && el.scrollLeft <= 0) {
        return
      }
      e.preventDefault()
      el.scrollLeft = Math.max(0, Math.min(maxScroll, nextLeft))
    },
    initData() {
      this.page = 1
      this.activities = []
      this.loading = true
      this.finished = false
      this.error = false
      this.onLoad()
    },
    switchHomeTransactionFilter(value) {
      if (this.homeTransactionFilter === value) {
        return
      }
      this.homeTransactionFilter = value
      this.activities = []
      this.page = 1
      this.loading = false
      this.finished = false
      this.error = false
      this.onLoad()
    },
    setAmount(amounts) {
      this.minAmount = amounts.minAmount
      this.maxAmount = amounts.maxAmount
      this.activities = []
      this.page = 1
      this.loading = false
      this.finished = false
      this.error = false
      this.onLoad()
    },
    toTransactionRecord() {
      this.$router.push({ name: 'TransactionRecord' })
    },
    toTransactionDetail(activityNo) {
      this.$router.push({
        name: 'TransactionDetail',
        query: { activityNo: activityNo }
      })
    },
    getDetailTypeByFilter() {
      const detailTypeMap = {
        PROXY_WITHDRAW: 1,
        SALARY: 2,
        AGENT_FEE: 3,
        GALA_SALARY: 4
      }
      return detailTypeMap[this.homeTransactionFilter]
    },
    //  获取用户交易记录
    getActivities() {
      this.loading = true
      const query = []
      if (this.minAmount) {
        query.push('minAmount=' + this.minAmount)
      }
      if (this.maxAmount) {
        query.push('maxAmount=' + this.maxAmount)
      }
      const detailType = this.getDetailTypeByFilter()
      if (detailType) {
        query.push('detailType=' + detailType)
      }
      query.push('pageSize=20&page=' + this.page)
      query.push('type=ALL')

      this.$http
        .get(window.serverPath + '/api/transactions?' + query.join('&'))
        .then((res) => {
          this.loading = false
          if (res.data && res.data.code === '200') {
            this.activities = this.activities.concat(res.data.data.list)
            if (this.page > res.data.data.totalPages) {
              this.finished = true
            } else {
              this.finished = false
            }
          } else {
            this.error = true
          }
        })
        .catch((err) => {
          this.loading = false
          this.error = true
          console.log(err)
        })
    },
    // 交易记录列表加载
    onLoad() {
      this.getActivities()
      this.page++
    }
  }
}
</script>

<style scoped>
.home_transaction_wrap {
  width: 100%;
  margin-top: 0.2rem;
}

.home_transaction_filter {
  box-sizing: border-box;
  width: calc(100% - 0.32rem);
  margin: 0 0.16rem 0.1rem;
}

.transaction_container {
  width: calc(100% - 0.32rem);
  height: 5rem;
  box-sizing: border-box;
  border-radius: 0.16rem;
  background: #fbfffd;
  box-shadow: 0 0 0.1rem 0 rgba(63, 187, 112, 0.2);
  backdrop-filter: blur(0.05rem);
  margin: 0 0.16rem 0.28rem;
  padding: 0 0.2rem;
}

.transaction_top {
  box-sizing: border-box;
  width: 100%;
  height: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  border-bottom: 0.01rem solid #efefef;
}

.transaction_top_right {
  color: #5b5b5b;
  font-weight: 400;
  display: flex;
  align-items: center;
}

.jump_icon {
  width: 0.1rem;
  height: 0.1rem;
  display: block;
  margin-inline-start: 0.04rem;
}

.jump_icon.mirror {
  transform: rotateY(180deg);
}

.top_btn_group {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  gap: 0.08rem;
}

.top_btn_scroll {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  overscroll-behavior-x: contain;
  touch-action: pan-x pinch-zoom;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  cursor: grab;
  user-select: none;
}

.top_btn_scroll::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.top_btn_scroll_is_dragging {
  cursor: grabbing;
}

.filter_btn {
  flex-shrink: 0;
  min-width: 0.56rem;
  height: 0.36rem;
  padding: 0 0.12rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.08rem;
  background: #fff;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
  margin-inline-end: 0.08rem;
  box-shadow: 0 0 0.04rem 0 rgba(63, 187, 112, 0.12);
  cursor: pointer;
}

.filter_btn_all{
  font-weight: 600;
}

.filter_btn.selected {
  color: #3fbb70;
  font-weight: 600;
}

.filter_icon {
  width: 0.36rem;
  height: 0.36rem;
  flex-shrink: 0;
  -webkit-user-drag: none;
  user-select: none;
}

.list_area {
  width: 100%;
  height: 4.5rem;
  overflow-y: auto;
  scrollbar-width: none;
}

.list_area::-webkit-scrollbar {
  width: 0;
}

.loading_box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.12rem;
  color: #969799;
}

.transaction_item_box {
  padding: 0.12rem 0;
  box-sizing: border-box;
  width: 100%;
  border-bottom: 0.01rem solid #efefef;
}

.transaction_item {
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.transaction_item_icon {
  width: 0.3rem;
  height: 0.3rem;
  display: block;
  margin-inline-end: 0.08rem;
  flex-shrink: 0;
}

.transaction_item_content {
  width: 2.3rem;
}

.transaction_item_des {
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.transaction_item_time {
  color: #828282;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.2rem;
}

.transaction_item_amount {
  margin-inline-start: auto;
  flex-shrink: 0;
  font-weight: 600;
}

.no_data_box {
  height: 100%;
}
</style>

<style>
.van-cell::after {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/HomeTransactionList.vue